import { Checkbox, Table, TableCell, TableContainer, TableRow, Tooltip, Typography } from '@mui/material';
import React from 'react'
import FunctionsIcon from '@mui/icons-material/Functions';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { selectLocationFromMaster } from 'src/features/staticDataSlice';
import { selectEndorsmentFormData, updateSumInsuredSectionData } from 'src/features/rfqDataSlice';

function AssetListItemVertical({ sumInsuredData, tableListDatas, groupDetails }) {
    const endorsementFormData = useSelector(selectEndorsmentFormData);
    const [locationMap, setLocationMap] = React.useState({});
    const locationMasterList = useSelector(selectLocationFromMaster);
    const dispatch = useDispatch();
    const sectionId = sumInsuredData.id;
    const groupId = groupDetails.id;

    const [selectedHeads, setSelectedHeads] = React.useState([]);

    React.useEffect(() => {
        // Whenever selectedHeads change, update Redux with sumInsuredEntry
        const hasSelectedHeads = selectedHeads.length > 0;

        dispatch(updateSumInsuredSectionData({
            sumInsuredSectionData: {
                [sectionId]: {
                    groups: {
                        [groupId]: {
                            verticalView: true,
                            sumInsuredSelectedHeads: selectedHeads,
                            sumInsuredEntry: hasSelectedHeads ? tableListDatas : [],
                            id:groupId
                        }
                    }
                }
            }
        }));
    }, [selectedHeads, tableListDatas, dispatch, sectionId, groupId]);

    const handleHeadCheckboxChange = (attribute, checked) => {
        setSelectedHeads(prev =>
            checked
                ? [...prev, attribute]
                : prev.filter(attr => attr !== attribute)
        );
    };
    React.useEffect(() => {
        if (locationMasterList?.length) {
            const map = {};
            locationMasterList.forEach((loc) => {
                const parts = [loc.name];
                if (loc.address) parts.push(loc.address);
                if (loc.pin) parts.push(loc.pin);
                map[loc.name] = parts.join(', ');
            });

            setLocationMap(map);
        }
    }, [locationMasterList]);
    return (
        <TableContainer sx={{ mt: 0 }}>

            <Table
                size="small"
                aria-label="a dense table"
                className="sum_insured_table"
            >
                {sumInsuredData?.sumInsuredHeaderSorted.map((head, rowIndex) => {
                    const attr = head.sumInsuredHeader.attribute;
                    const title = head.title || head.sumInsuredHeader.title;
                    const isChecked = selectedHeads.includes(attr);
                    const isEditableAllowed =
                        endorsementFormData?.type === 'Both' ||
                        (endorsementFormData?.type === 'Financial' &&
                            head?.endorsementSubTypes?.financial?.includes(endorsementFormData?.subType)) ||
                        (endorsementFormData?.type === 'NonFinancial' &&
                            head?.endorsementSubTypes?.nonFinancial?.includes(endorsementFormData?.subType));

                    return <TableRow key={rowIndex} style={{ height: '40px' }}>
                        <TableCell style={{ width: '505px', paddingLeft: '8px' }}>
                            <div>    
                            {!isEditableAllowed ? (
                                <Tooltip title="Editing disabled due to subtype restriction">
                                    <span>
                                        <Checkbox
                                            disabled
                                        />
                                    </span>
                                </Tooltip>
                            ) : (
                                <Checkbox
                                    checked={isChecked}
                                    onChange={(e) =>
                                        handleHeadCheckboxChange(attr, e.target.checked)
                                    }
                                    style={{ paddingTop: '0px', paddingBottom: '0px' }}
                                />)}
                                {title}
                            </div>

                        </TableCell>
                        {tableListDatas?.map((_, index) => {
                            return (
                                <React.Fragment
                                    key={index}
                                >

                                    {sumInsuredData?.sumInsuredHeaderSorted.map((item) => {
                                        const attr = item.sumInsuredHeader.attribute;
                                        const headAttr = head.sumInsuredHeader.attribute;
                                        const value = tableListDatas[index][attr];

                                        if (attr !== headAttr) return null;

                                        const formattedValue = () => {
                                            if (!value || (Array.isArray(value) && value.length === 0)) return 'N/A';

                                            // Location formatting
                                            if (attr === 'location') {

                                                return locationMap?.[value] || value;
                                            }

                                            // Date fields
                                            const dateFields = [
                                                'retroActiveDate', 'journeyStartDate', 'journeyEndDate',
                                                'expectedDateOfCommencementOfErection,projectStartDateOfFirstConsignment',
                                                'yearOfManufacture', 'dateOfCommencementOfTransit',
                                                'invoiceNoAndDate', 'billOfLadingAndDate'
                                            ];

                                            if (dateFields.includes(attr)) {
                                                return moment(value).format('YYYY-MM-DD');
                                            }

                                            // Array values
                                            if (Array.isArray(value)) {
                                                return value.join(', ');
                                            }

                                            // Default case
                                            return value;
                                        };

                                        return (
                                            <TableCell className='Pad3' key={attr}>
                                                {formattedValue()}
                                            </TableCell>
                                        );
                                    })}



                                </React.Fragment>
                            );
                        })}
                    </TableRow>
                })}
                {parseFloat(groupDetails.totalSumInsured) > 0 && sumInsuredData.showTotalSumInsured ? (
                    <TableRow>
                        <TableCell className='Pad3'

                        ><Typography variant="h5" style={{ marginTop: 9, textAlign: 'right' }}>
                                Total
                            </Typography></TableCell>
                        <TableCell className='Pad3' >
                            <Typography variant="h5" style={{ marginTop: 9, textAlign: 'left' }}>: {groupDetails.totalSumInsured ? parseFloat(groupDetails.totalSumInsured)?.toFixed(2) : '0.00'}</Typography>
                        </TableCell>
                    </TableRow>
                ) : null}

            </Table>

        </TableContainer>
    )
}

export default AssetListItemVertical